jQuery(document).ready(function($) {
    var btn = $('#back-button'); // Ensure you're using the $ alias inside this block

    // Monitor scroll events
    $(window).scroll(function() {
        if ($(window).scrollTop() > 300) {
            btn.addClass('show');
        } else {
            btn.removeClass('show');
        }
    });

    // Smooth scroll to top when the button is clicked
    btn.on('click', function(e) {
        e.preventDefault();
        $('html, body').animate({scrollTop: 0}, '300');
    });

  $('.navmenu-id-privacy a').attr('target', '_blank');
  $('.navmenu-id-terms-of-service a').attr('target', '_blank');
  $("#contact_message").on("input", function () {
    const value = $(this).val();
    // Remove leading spaces
    if (/^\s/.test(value)) {
      $(this).val(value.trimStart());
    }
  });

  $(".cart-item--remove-link").on("click", function (e) {
    e.preventDefault(); // Prevent the default link action
    const removeUrl = $(this).attr("data-href"); // Get the URL from the link
    
    // Display confirmation dialog
    const confirmRemove = confirm("Are you sure you want to remove this item from the cart?");
    
    if (confirmRemove) {
      // If confirmed, perform the action by redirecting to the URL
      window.location.href = removeUrl;
    }
  });

  $("body").on("click", ".open-quick-view", function(e) {
    
    setTimeout(function() {
        $('input[name="quantity"]').removeAttr('max');
        console.log("Max attribute removed");
    }, 3000); // 3 seconds delay
  });
  
  $("body").on("click",".button_chat",function(e){
     if (window.tidioChatApi) {
        window.tidioChatApi.open(); // Opens Tidio chat on button click
      } else {
        console.warn("Tidio chat API not loaded yet.");
      }
  });

    const selector = $('#variantSelector');
    const skuOutput = $('#skuOutput');
    if (selector.length && skuOutput.length) {
      selector.on('change', function () {
        const selectedSku = $(this).find(':selected').data('sku');
        if(selectedSku){
          skuOutput.html(selectedSku);
        }
      });
    }

    // Collection description read more functionality
    $('body').on('click', '[data-collection-description-toggle]', function(e) {
        e.preventDefault();
        
        const $button = $(this);
        const $preview = $('[data-collection-description-preview]');
        const $full = $('[data-collection-description-full]');
        const $buttonText = $button.find('[data-collection-description-text]');
        const isExpanded = $button.attr('aria-expanded') === 'true';
        
        if (isExpanded) {
            // Collapse - show preview, hide full
            $preview.slideDown(300);
            $full.slideUp(300);
            $button.attr('aria-expanded', 'false');
            $buttonText.text($buttonText.data('see-more') || 'See more');
        } else {
            // Expand - hide preview, show full
            $preview.slideUp(300);
            $full.slideDown(300);
            $button.attr('aria-expanded', 'true');
            $buttonText.text($buttonText.data('see-less') || 'See less');
        }
    });

    // Initialize read more button text on page load
    $(document).ready(function() {
        const $button = $('[data-collection-description-toggle]');
        const $buttonText = $('[data-collection-description-text]');
        if ($button.length && $buttonText.length) {
            // Store the see more and see less texts from data attributes
            const seeMoreText = $button.data('see-more') || $buttonText.text() || 'See more';
            const seeLessText = $button.data('see-less') || 'See less';
            
            $buttonText.data('see-more', seeMoreText);
            $buttonText.data('see-less', seeLessText);
        }
    });
});

  


